import DashboardLayout from '../../components/dashboard/DashboardLayout';
import PaymentHistoryContent from '../guest/PaymentHistory';

const PaymentHistoryPage = () => {
  return (
    <DashboardLayout>
      <PaymentHistoryContent />
    </DashboardLayout>
  );
};

export default PaymentHistoryPage; 